<template>
	<div>
		<div class="page_header">
			<span class="page_title">{{ $t('operatormgr.page_title') }}</span>
			<el-form :inline="true" :size="size" style="flex:1;text-align: right;">
				<el-form-item :label="$t('operatormgr.ope_name') + ':'">
					<el-input clearable v-model="form.OperatorName"
						:placeholder="$t('operatormgr.please_ope_name')"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSubmit">{{ $t('public.query') }}</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="success" @click="onAddClick">{{ $t('public.add') }}</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="page_container">
			<el-table :size="size" :data="tableData" border style="width: 100%">

				<el-table-column prop="OPTNickName" align="center" :label="$t('operatormgr.nickName')">
				</el-table-column>
				<el-table-column prop="OPTName" align="center" :label="$t('operatormgr.ope_name')">
				</el-table-column>
				<el-table-column prop="MobileTel" align="center" :label="$t('operatormgr.mobileTel')">
				</el-table-column>
				<el-table-column prop="EMail" align="center" label="Email">
				</el-table-column>
				<el-table-column prop="IsManager" align="center" :label="$t('operatormgr.opt_type')">
					<template slot-scope="scope">
						<el-tag :size="size" v-if="scope.row.IsManager == 'true'" type="danger">{{
                            $t('operatormgr.sup_manage') }}</el-tag>
						<el-tag :size="size" v-else>{{ $t('operatormgr.normal_manage') }}</el-tag>
					</template>
				</el-table-column>

				<el-table-column prop="updatetime" align="center" :label="$t('public.Operation')" width="270">
					<template slot-scope="scope">
						<el-row style="margin-top: 0;">
							<el-button type="success" size="mini" @click="onResetClick(scope.row)">{{
                                $t('operatormgr.initpsw') }}</el-button>
							<el-button type="primary" size="mini" @click="onEditClick(scope.row)">{{ $t('public.edit')
                            }}</el-button>
							<el-button type="warning" size="mini" @click="onDeleteClick(scope.row)">{{ $t('public.del')
                            }}</el-button>
						</el-row>
					</template>

				</el-table-column>
			</el-table>

			<kl-pagination style="margin-bottom: 10px;" :total="total" @current-change="pageChange"
				:current-page.sync="form.PageNo">
			</kl-pagination>
		</div>
		<info ref="model" @ok="submitOk" />
	</div>
</template>

<script>
	import info from "./operatorinfo.vue"
	let Base64 = require("js-base64").Base64;
	export default {
		name: "operatormgr",
		components: {
			info
		},
		data() {
			return {
				loading: false,
				form: {
					OperatorID: 0,
					OperatorName: '',
					PageNo: 1,
					PageSize: 10
				},
				tableData: [],
				total: 0,
				initPsw: "Kingwings@123"
			}
		},
		computed: {
			size() {
				return this.$store.getters.size
			},
			operator() {
				return this.$store.getters.operator
			},
		},
		methods: {
			submitOk() {
				this.queryList();
			},
			onAddClick() {
				this.$refs.model.add();
			},
			onEditClick(row) {
				this.$refs.model.edit(row);
			},
			//初始化密码为随机密码
			generatePassword() {
				const chars =
					'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijk1mnopqrstuvwxyz0123456789!@#$%^&amp;*()_+{}[]|\\;:\'",./<>?';
				let password = '';
				for (let i = 0; i < 10; i++) {
					const randomIndex = Math.floor(Math.random() * chars.length);
					password += chars[randomIndex];
				}
				return password;
			},
			onResetClick(row) {
				this.initPsw = this.generatePassword()
				this.$confirm(this.$t("operatormgr.initpsw_comfirm", {
					nickName: row.OPTNickName,
					initpsw: this.initPsw
				}), this.$t("public.tips"), {
					confirmButtonText: this.$t("public.confirm"),
					cancelButtonText: this.$t("public.cancel"),
					type: 'warning'
				}).then(() => {
					this.$api.reInitOpertator({
						OperatorID: row.OPT_ID,
						Keys: Base64.encode(this.initPsw)
					}).then(res => {
						if (res && res.code == 200 && res.data == 1) {
							//删除成功
							this.$message.success(this.$t("operatormgr.initpsw_success"));
							this.queryList();
						} else {
							this.$message.error(this.$t("operatormgr.initpsw_fail"));
						}
					})

				}).catch(() => {

				});
			},
			onDeleteClick(row) {
				//确定要删除吗？
				this.$confirm(this.$t("operatormgr.del_comfirm", {
					nickName: row.OPTNickName
				}), this.$t("public.tips"), {
					confirmButtonText: this.$t("public.confirm"),
					cancelButtonText: this.$t("public.cancel"),
					type: 'warning'
				}).then(() => {
					this.$api.deleteOperator({
						OperatorID: row.OPT_ID
					}).then(res => {
						if (res && res.code == 200 && res.data == 1) {
							//删除成功
							this.$message.success(this.$t("operatormgr.del_success"));
							this.queryList();
						} else {
							this.$message.error(this.$t("operatormgr.del_fail"));
						}
					})

				}).catch(() => {

				});
			},
			pageChange(page) {
				this.form.PageNo = page;
				this.queryList();
			},
			queryList() {
				this.loading = true;
				this.$api.queryOperatorList(this.form).then(res => {
					this.loading = false;
					if (res && res.code == 200) {
						this.tableData = res.data.data;
						this.total = res.data.recordsTotal
					}

				}).catch(() => {
					this.loading = false;
				});
			},
			init() {
				this.form.OperatorID = this.operator.OperatorId;
			},
			onSubmit() {
				this.form.PageNo = 1;
				this.queryList();
			}

		},
		mounted() {
			this.init();
			this.queryList();
		}
	}
</script>
<style scoped lang="scss"></style>